import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

import styled from 'styled-components';

const CustomDivider = styled(Divider)`
  width: 1px;
  height: 40px;
  margin: 4px;
`;

const CustomPaper = styled(Paper)`
  padding: 2px 4px;
  display: flex;
  align-items: center;
  justify-content: space-arround;
`;

const Search = ({ setPage, setQuery, query }) => {
  const [inputText, setInputText] = useState('');
  const handleChange = event => {
    setInputText(event.target.value);
  };

  const reset = () => {
    setInputText('');
    setQuery('');
    setPage(0);
  };

  const search = () => {
    setQuery(inputText);
    setPage(0);
  };

  const keyPressed = event => {
    if (event.key === 'Enter') {
      search();
    }
  };
  return (
    <CustomPaper>
      <TextField
        style={{ margin: '5px 30px 5px 30px', width: '80%' }}
        placeholder="Référence de la commande, nom, prénom du client"
        id="name"
        label="Recherche"
        value={inputText}
        onChange={handleChange}
        onKeyPress={keyPressed}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton aria-label="Search" onClick={search}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      <CustomDivider />
      <Button
        color="primary"
        variant="contained"
        disabled={query === ''}
        style={{ marginRight: 30, marginLeft: 30 }}
        onClick={reset}
      >
        Réinitialiser
      </Button>
    </CustomPaper>
  );
};

Search.propTypes = {
  setPage: PropTypes.func.isRequired,
  setQuery: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired
};

export default Search;
